import { css } from '@emotion/react'
import { Text } from 'components/Typography'
import { Stack } from 'components/Stack'
import { pxToRem } from 'utils/styled'
import { Icon } from 'components/icon'

export function DigitalLegacyAuthorItem(props: {
  src?: string | null
  srcSet?: string | null
  name?: string | null
  description?: string | null
  social: {
    facebook?: string | null
    linkedin?: string | null
    twitter?: string | null
    instagram?: string | null
  }
  className?: string
}) {
  return (
    <Stack css={{ alignItems: 'center' }} space={`${pxToRem(24)}rem`} className={props.className}>
      <img
        src={props.src ?? undefined}
        srcSet={props.srcSet ?? undefined}
        alt={props.name ?? undefined}
        css={css`
          margin-bottom: ${pxToRem(24)}rem;
          border-radius: 100%;

          max-width: ${pxToRem(120)}rem;
        `}
      />
      <Stack space="1rem">
        <Text
          as="h3"
          css={css`
            font-size: ${pxToRem(28)}rem;
            color: var(--c-gray100);
          `}
        >
          {props.name}
        </Text>
        <Text>{props.description}</Text>

        <Stack
          orientation="horizontal"
          space={`${pxToRem(28)}rem`}
          css={css`
            align-items: center;
            justify-content: center;
            color: var(--c-gray100);

            & a,
            & a:visited {
              color: var(--c-gray100);
            }
          `}
        >
          {props.social.facebook && (
            <a target="_blank" rel="noreferrer" href={props.social.facebook}>
              <Icon name="Facebook" />
            </a>
          )}
          {props.social.linkedin && (
            <a target="_blank" rel="noreferrer" href={props.social.linkedin}>
              <Icon name="LinkedIn" />
            </a>
          )}
          {props.social.twitter && (
            <a target="_blank" rel="noreferrer" href={props.social.twitter}>
              <Icon name="Twitter" />
            </a>
          )}
          {props.social.instagram && (
            <a target="_blank" rel="noreferrer" href={props.social.instagram}>
              <Icon name="Instagram" />
            </a>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}
